import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  initials,
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 rounded-lg border border-white/5 flex flex-col h-full hover:border-brand-accent/40 transition-colors" data-id="element-230">
    <div className="flex items-center mb-2" data-id="element-231">
      <div className="w-9 h-9 bg-brand-accent text-brand-dark rounded-full flex items-center justify-center font-black text-xs mr-2.5 shrink-0" data-id="element-232">
        {initials}
      </div>
      <div data-id="element-233">
        <div className="flex text-brand-accent mb-0.5" data-id="element-234">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 fill-current" data-id="element-235" />)}
        </div>
        <p className="font-bold text-white text-xs leading-tight" data-id="element-236">{name}</p>
        <p className="text-[10px] text-gray-500 font-medium" data-id="element-237">{location}</p>
      </div>
    </div>
    <p className="text-gray-300 text-xs italic flex-grow leading-relaxed font-medium" data-id="element-238">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariana G.',
    location: 'Entrenadora de Vóley — Buenos Aires, Argentina',
    text: 'Organicé todo mi año de clases de vóley en una tarde.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Profesora de Vóley — Bogotá, Colombia',
    text: 'Mis alumnos por fin tienen progresión real y no abandonan.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Entrenador de Vóley — Ciudad de México, México',
    text: 'Nunca más llegué a dar una clase sin saber qué enseñar.'
  }];
  return <section className="py-4 md:py-6 px-4 bg-brand-cardAlt" data-id="element-239">
      <div className="max-w-4xl mx-auto" data-id="element-240">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-241">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-242" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariana G.',
    location: 'Entrenadora de Vóley | Buenos Aires, Argentina',
    text: 'Compré el Kit un domingo a la noche. El lunes tenía todo el mes de clases organizado. Los guiones de clase son exactamente lo que necesitaba: no tengo que pensar de cero para cada sesión. Los errores, las correcciones y lo que decirle al alumno en cada momento — todo está ahí.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Profesora de Vóley | Montevideo, Uruguay',
    text: 'Empecé con el Kit Base y a los tres días compré el Completo. El Bono de Juegos y Dinámicas me cambió las clases grupales: mis alumnos ahora no faltan nunca porque se enganchan desde el primer minuto.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Entrenador de Vóley | Ciudad de México, México',
    text: 'El Tomo de Planificación Profesional me salvó el año. Con el Kit resolví un mes completo de clases en 30 minutos con progresión, contenido y formato incluidos. Mis alumnos me preguntaron si había hecho algún curso nuevo.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    location: 'Entrenador de Vóley | Santiago, Chile',
    text: 'Lo que más valoro es que está organizado por nivel. No tengo que adivinar qué ejercicio le corresponde a cada alumno ni cuándo avanzar. Es como tener un colega experto que ya hizo todo el trabajo por mí.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Profesora de Vóley | Bogotá, Colombia',
    text: 'Como entrenadora de nivel intermedio lo que más me cambió fueron los Tomos 4 y 5. Mis alumnos por fin se enganchan con las clases porque el contenido los desafía de verdad.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    location: 'Entrenadora de Vóley | Lima, Perú',
    text: 'Tengo grupos muy grandes y siempre fue un caos organizarlos. El Tomo de Metodología me explicó exactamente cómo diferenciar niveles dentro del mismo grupo y mantener el ritmo. Ahora mis clases fluyen solas.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-243">
      <div className="max-w-5xl mx-auto" data-id="element-244">
        <h2 className="text-lg md:text-2xl font-black text-center mb-5 text-white" data-id="element-245">
          Lo que dicen los entrenadores que ya tienen su Kit
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-246">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-247" />)}
        </div>
      </div>
    </section>;
}